import "@/assets/vendor/nucleo/css/nucleo.css";
import "@/assets/vendor/font-awesome/css/font-awesome.css";
import "@/assets/scss/argon.scss";
import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives";
import VueLazyload from "vue-lazyload";



// Highcharts plugin and GoogleCharts plugin
import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import stockInit from 'highcharts/modules/stock';
import xrangeInit from 'highcharts/modules/xrange';
import sankeyInit from 'highcharts/modules/sankey';
import mapInit from 'highcharts/modules/map';
import fillInit from 'highcharts/modules/pattern-fill';
import moreInit from 'highcharts/highcharts-more';
import exportingInit from 'highcharts/modules/exporting'
import exportingDataInit from 'highcharts/modules/export-data';

fillInit(Highcharts);
moreInit(Highcharts);
sankeyInit(Highcharts);
xrangeInit(Highcharts);
stockInit(Highcharts);
mapInit(Highcharts);
exportingInit(Highcharts);
exportingDataInit(Highcharts);

Highcharts.setOptions({
  colors: ['#1563a0', '#42b883', '#f7a35c', '#314b5f', '#613a6f', '#ee3424', '#2c68f5', '#f47c71'],
  chart: {
    style: {
      fontFamily: 'sans-serif',
      fontSize: '11px'
    }
  }
});

export default {
  install(Vue) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
    Vue.use(VueLazyload);
    Vue.use(HighchartsVue);
  }
};
